import * as React from 'react';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import {withStore} from "../hocs";
import {observer} from "mobx-react";
import QuizModalWindowThank from "../components/modalWindow/QuizModalWindowThank";



interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{p: 3}}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


// @ts-ignore
@withStore
@observer
export default class QuizPage extends React.Component {
    componentDidMount() {
        // @ts-ignore
        const {store} = this.props;
        store?.pageBasketStore.init();

    }


    render() {
        // @ts-ignore
        const {store} = this.props;
        const {
            value,
            arrayValue,
            handleChange,
            moveLeft,
            moveRight,
            handleChangeInputValue,
            handleChangeLessValue,
            valueLess,
            postAnswer
        } = store?.pageQuizStore


        return (
            <>
                <Box sx={{width: '75%', margin: "auto"}}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <Tabs value={value} onChange={handleChange}
                              variant="scrollable"
                              scrollButtons="auto"
                              aria-label="basic tabs example"
                        >
                            {arrayValue.map((item: any) =>
                                <Tab label={item.title} {...a11yProps(item.id)}  />
                            )}

                        </Tabs>
                    </Box>
                    {arrayValue.map((item: any, ind: number) =>
                        <TabPanel value={value} index={item.id}>
                            <div style={{padding: 10}}>
                                {value === arrayValue.length - 1 ? null :
                                    <>
                                        {value === 0 ? null :
                                            <span className="to-basket__btn to-basket__text in-basket"
                                                  style={{marginRight: 10}}
                                                  onClick={() => moveRight(value)}>Назад</span>
                                        }
                                        <span className="to-basket__btn to-basket__text in-basket"
                                              onClick={() => moveLeft(value)}> Вперед</span>
                                    </>
                                }

                            </div>

                            <>{item.checkbox || item.inputField ? <>
                                <FormLabel>{item.subTitle}</FormLabel>
                                <FormGroup>
                                    {item.answerCheckBox.map((item3: any) =>
                                        <FormControlLabel
                                            control={<Checkbox/>}
                                            onChange={() => {
                                                handleChangeLessValue(item3, ind, item.checkbox)
                                            }}
                                            checked={item.indexValueSelectedCheckBox.includes(item3)}
                                            label={item3}/>
                                    )}
                                </FormGroup>

                            </> : null}</>


                            {item.inputField && ind !== 9 ? <Box
                                component="form"
                                sx={{
                                    '& > :not(style)': {m: 1, width: '35ch'},
                                }}
                                noValidate
                                autoComplete="off"
                            >

                                <TextField id="standard-basic" label={item.inputTittle}
                                           defaultValue={item.inputValue} onChange={event => {
                                    handleChangeInputValue(event.target.value, ind)
                                }} variant="standard"/>
                            </Box> : null}
                            {item.inputField && ind === 9 ? <Box
                                component="form"
                                sx={{
                                    '& > :not(style)': {m: 1, width: '40ch'},
                                }}
                                noValidate
                                autoComplete="off"
                            >

                                <TextField id="standard-basic" label={item.inputTittle}
                                           defaultValue={item.inputValue} onChange={event => {
                                    handleChangeInputValue(event.target.value, ind)
                                }} variant="standard"/>
                            </Box> : null}


                            <>{item.radioButton ? <>
                                <FormControl>

                                    <FormLabel>{item.subTitle}</FormLabel>

                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        name="radio-buttons-group"
                                        defaultValue={arrayValue[ind].indexValueSelected}
                                    >
                                        {item.answerRadioButton.map((item2: any,) =>
                                            <FormControlLabel
                                                onChange={() => {
                                                    handleChangeLessValue(item2, ind, item.checkbox)
                                                }}
                                                value={item2}
                                                control={<Radio/>} label={item2}/>
                                        )}
                                        <>
                                            {valueLess ? <Box
                                                component="form"
                                                sx={{
                                                    '& > :not(style)': {m: 1, width: '25ch'},
                                                }}
                                                noValidate
                                                autoComplete="off"
                                            >

                                                <TextField id="standard-basic" label={item.inputTittle}
                                                           defaultValue={item.inputValue} onChange={event => {
                                                    handleChangeInputValue(event.target.value, ind)
                                                }} variant="standard"/>
                                            </Box> : null}
                                        </>
                                    </RadioGroup>

                                </FormControl>

                            </> : null}</>

                            <div>
                                {value + 1} из {arrayValue.length}
                            </div>
                            <div>
                                {value === arrayValue.length - 1 ?
                                    <button className="to-basket__btn" onClick={() => postAnswer()}
                                            style={{
                                                display: "block",
                                                margin: "auto"
                                            }}>
                                        <span className="to-basket__text ">Отправить результат</span>
                                    </button>
                                    : null
                                }

                            </div>
                        </TabPanel>
                    )}
                </Box>

                <QuizModalWindowThank/>
            </>

        )
    }
}